import { processError } from '../auth';

const deleteMe = (softReset = false) => {
  let url = new URL(process.env.GATSBY_BASE_URL + 'livquest/me/');
  if (softReset) {
    url.searchParams.append('soft_reset', 'true');
  }

  const token = localStorage.getItem('questCode');
  return fetch(url, {
    method: 'DELETE',
    headers: { Authorization: `Quest ${token}`, 'Content-Type': 'application/json' },
  })
    .then((response) => {
      if (response.status === 204) {
        return { success: true };
      }
      throw new Error('Failed to delete');
    })
    .catch((err) => {
      processError(err, 'livquestDeleteMe');
    });
};

export { deleteMe };
